"use client";

import React from "react";
import { Star } from "lucide-react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
export default function ClientExperiences() {
  const testimonials = [{
    author: "Sophie van der Berg",
    quote: "Fantastische service en supervriendelijk team. Er werd echt geluisterd naar mijn wensen en het resultaat was precies wat ik zocht.",
    position: "Klant sinds 2022",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1620688/img/testimonial_1.png"
  }, {
    author: "Mark de Vries",
    quote: "Mooie zaak, professioneel advies en top resultaat. Ook fijn dat ze alles duidelijk uitleggen voor te beginnen.",
    position: "Vaste Klant",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1620688/img/testimonial_2.png"
  }];
  return <section data-section-id="149055" id="klant-ervaringen" className="relative w-full py-24 md:py-32 overflow-hidden bg-background text-foreground">
      [trustindex no-registration=google]
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,var(--color-primary)_0%,transparent_70%)] opacity-20 pointer-events-none" />

      <div className="container mx-auto px-4 md:px-6 relative z-10">
      </div>
    </section>;
}